import Attributes_AttributesPage from "@Alternatives/Attributes/Pages/AttributesPage.vue";

export const routes = [
    {
        path: "/portfolio/attributes/:workspaceId/:projectId/:include?",
        component: Attributes_AttributesPage
    },
    {
        path: "/decision/attributes/:workspaceId/:projectId/:include?",
        component: Attributes_AttributesPage
    },
]
